export const localStorageService = (function () {
  var _service
  function _getService() {
    if (!_service) {
      _service = this
      return _service
    }
    return _service
  }
  function _setToken(tokenObj) {
    localStorage.setItem(
      'token',
      JSON.stringify({
        access_token: tokenObj.access_token || '',
        refresh_token: tokenObj.refresh_token || '',
        access_token_exp: tokenObj.access_token_exp || '',
        refresh_token_exp: tokenObj.refresh_token_exp || '',
      })
    )
  }
  function _getToken() {
    return JSON.parse(localStorage.getItem('token')) || {}
  }
  function _getAccessToken() {
    return (JSON.parse(localStorage.getItem('token')) || {}).access_token
  }
  function _getRefreshToken() {
    return (JSON.parse(localStorage.getItem('token')) || {}).refresh_token
  }
  function _clearToken() {
    localStorage.removeItem('token')
  }
  function _clearEmail() {
    localStorage.removeItem('email')
  }
  function _clearRoleUser() {
    localStorage.removeItem('roleUser')
  }
  function _clearRoleUserData() {
    localStorage.removeItem('userData')
  }
  function getUserData() {
    return localStorage.getItem('userData')
  }
  function _clearRoleUserMulti() {
    localStorage.removeItem('roleUserMulti')
  }
  function _setTime(prevTime, curTime) {
    localStorage.setItem('prevTime', prevTime)
    localStorage.setItem('currentTime', curTime)
  }
  function _getPrevTime() {
    return localStorage.getItem('prevTime')
  }
  function _getCurTime() {
    return localStorage.getItem('currentTime')
  }
  function _clearRfqID() {
    return localStorage.getItem('rfqId')
  }
  const setSupplierManagement = id => {
    return localStorage.setItem('rfqIdBuyerSupplier', id)
  }
  const clearSupplierManagement = () => {
    return localStorage.removeItem('rfqIdBuyerSupplier')
  }
  const getSupplierManagement = () => {
    return localStorage.getItem('rfqIdBuyerSupplier')
  }
  const setSourcingCompare = id => {
    return localStorage.setItem('rfqIdBuyerSourcing', id)
  }
  const getSourcingCompare = () => {
    return localStorage.getItem('rfqIdBuyerSourcing')
  }
  const clearSourcingCompare = () => {
    return localStorage.removeItem('rfqIdBuyerSourcing')
  }
  const setSourcingDetail = id => {
    return localStorage.setItem('rfqId', id)
  }
  const getSourcingDetail = () => {
    return localStorage.getItem('rfqId')
  }
  const clearSourcingDetail = () => {
    return localStorage.removeItem('rfqId')
  }
  const clearRole = () => {
    return localStorage.removeItem('role')
  }
  const setCompanyId = id => {
    return localStorage.setItem('companyId', id)
  }
  const getCompanyId = () => {
    return localStorage.getItem('companyId')
  }
  const clearCompanyId = () => {
    return localStorage.removeItem('companyId')
  }
  const setBuyerId = id => {
    return localStorage.setItem('buyerId', id)
  }
  const getBuyerId = () => {
    return localStorage.getItem('buyerId')
  }
  const clearBuyerId = () => {
    return localStorage.removeItem('buyerId')
  }
  // set name users
  const setUsersName = name => {
    return localStorage.setItem('username', name)
  }
  const getUsersName = () => {
    return localStorage.getItem('username')
  }
  const clearUsersName = () => {
    return localStorage.removeItem('username')
  }

  const setTokenCheckFromEmail = token => {
    return localStorage.setItem('tokenCheck', token)
  }
  const getTokenCheckFromEmail = () => {
    return localStorage.getItem('tokenCheck')
  }
  const clearTokenCheckFromEmail = () => {
    return localStorage.removeItem('tokenCheck')
  }
  const _setUser = user => {
    localStorage.setItem('user', JSON.stringify(user))
  }
  const _getUser = () => {
    const localUser = localStorage.getItem('user')
    if (localUser) return JSON.parse(localUser)

    return null
  }
  return {
    getService: _getService,
    setToken: _setToken,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    clearToken: _clearToken,
    clearEmail: _clearEmail,
    clearRoleUser: _clearRoleUser,
    clearRoleUserData: _clearRoleUserData,
    clearRoleUserMulti: _clearRoleUserMulti,
    _setTime: _setTime,
    _getPrevTime: _getPrevTime,
    _getCurTime: _getCurTime,
    clearRfqID: _clearRfqID,
    getUserData: getUserData,
    setSupplierManagement,
    clearSupplierManagement,
    getSupplierManagement,
    setSourcingCompare,
    getSourcingCompare,
    clearSourcingCompare,
    setSourcingDetail,
    getSourcingDetail,
    clearSourcingDetail,
    clearRole,
    setCompanyId,
    getCompanyId,
    clearCompanyId,
    setBuyerId,
    getBuyerId,
    clearBuyerId,
    setUsersName,
    getUsersName,
    clearUsersName,
    setTokenCheckFromEmail,
    getTokenCheckFromEmail,
    clearTokenCheckFromEmail,
    setUser: _setUser,
    getUser: _getUser,
    getToken: _getToken,
  }
})()
